import { render, staticRenderFns } from "./ChipList.vue?vue&type=template&id=31ee1ab0&lang=pug"
import script from "./ChipList.vue?vue&type=script&lang=js"
export * from "./ChipList.vue?vue&type=script&lang=js"
import style0 from "./ChipList.vue?vue&type=style&index=0&id=31ee1ab0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports